import AxiosInatance from "axios";
import config from "./config";
import { renderOptionHandler,deepCopy_Object, showToast,dataReadFunction,dateTimeFormater } from "./functions";

export const getConnection=(base_URL, passToken = null)=> {
    let projectId = localStorage.getItem("project")
    if (!projectId) {
        projectId = "WMS"
    }
    const headers = {
        "Content-Type": "application/json",
        "Authorization": JSON.parse(localStorage.getItem("token")),
        "Access_type": "service",
        "Project": projectId,
        ...(passToken ? { Partialaccesstoken: passToken } : {})
    }
    let connection = AxiosInatance.create({
        "baseURL": base_URL || config.baseURL || "/v1/",
        "headers": headers
    });
    // console.log("baseURL>>>>>>",base_URL)

    return connection

}

export const calculateTarget = (rowElement,item, data = null) => {
    for (let key in item.onChangeSet) {
        let value;
        let keyArr = []
        if (item.onChangeSet[key].includes("$")) {
            keyArr = item.onChangeSet[key].split(".")
            if (keyArr[0] == '$response') {
                value = data
            }
            else {
                if (item.type == 'select' && item.values && item.values.length) {
                    value = item.values.find(el => el[item.apiBindingValue ? item.apiBindingValue : "value"] == item.value)
                }
                else {
                    value = item.value
                }
            }
            keyArr = keyArr.slice(1)
        }
        else {
            value = data
            keyArr = item.onChangeSet[key].split(".")
        }
        for (let key of keyArr) {
            if(value){
                value = value[key]
            }
            else{
                value=""
                break;
            }
        }
        setTarget(rowElement,key, value)
    }
}

export const setTarget = (rowElement,key, data="",skipSplit=true) => {
    if(skipSplit){
        rowElement[key]=data
        if(!rowElement["disabled"])rowElement["disabled"]=[]
        if(typeof data=="number" ? data && data>0:data?.length>0){
            rowElement["disabled"].push(key)
        }
    }
    else{
        let new_target = key.split("-")
        if (new_target.length == 1) {
            rowElement[key]=data
        }
        else {
            rowElement[key]={[new_target[1]]:data }
        }
        if(!rowElement["disabled"])rowElement["disabled"]=[]
        if(typeof data=="number" ? data && data>0: data?.length>0){
            rowElement["disabled"].push(new_target.pop())
        }
       

    }
}
export const calculateTargetAPIParams = (item={},valueIn,type="apiParameters",detailObject={}) => {
    try{
        let obj={},value=valueIn && typeof valueIn=="string" && valueIn.split("(")?.at(0) || valueIn || "";
        // let obj={};
        if (type == "apiParameters" && item.apiParameters && item.apiParameters.length) {
            let $self = ''
            if (item.type == 'select' && item.values && item.values.length) {
                $self = item.values.find(el => el[item.apiBindingValue ? item.apiBindingValue : "value"] == value)
            }
            else {
                $self = value
            }
            for (let el of item.apiParameters) {
                if (el.value && typeof el.value != "number" && (el.value + "").includes("$target")) {
                    let targetValue = detailObject || {}
                    let keyArr = el.value.split(".")
                    keyArr = keyArr.slice(1)
                    for (let key of keyArr) {
                        if (typeof targetValue != "object") {
                            targetValue = ""
                            break;
                        }
                        targetValue = targetValue[key]
                    }
                    if (el?.required && !targetValue) {
                        return { success: false, params: {} }
                    }
                    appendData(targetValue, el.label)
                }
                else {
                    if (el?.required && !el.value) {
                        return { success: false, params: {} }
                    }
                    if (el.value && typeof el.value != "number" && (el.value + "").includes("$self")) {
                        let value = $self
                        let keyArr = el.value.split(".")
                        keyArr = keyArr.slice(1)
                        for (let key of keyArr) {
                            if(typeof value!="object"){
                                value=""
                                break;
                            }
                            value = value[key]
                        }
                        appendData(value, el.label)
                    }
                    else if (el.value == "onSearch") {
                        appendData(value, el.label)
                    }
                    else {
                        appendData(el.value == 'self' ? value : el.value, el.label)
                    }
                }
                // if (el.value) {
                // }
            }
            // item.apiParameters.forEach(el => {
            // });
        }
        else if (type=="targetParameters" && item.targetParameters && item.targetParameters.length) {
            let $self = ''
            if (item.type == 'select' && item.values && item.values.length) {
                $self = item.values.find(el => el[item.apiBindingValue ? item.apiBindingValue : "value"] == value)
            }
            else {
                $self = value
            }
    
            for(let el of item.targetParameters) {
                if (el.value && typeof el.value != "number" && (el.value + "").includes("$target")) {
                    let targetValue = detailObject || {}
                    let keyArr = el.value.split(".")
                    keyArr = keyArr.slice(1)
                    for (let key of keyArr) {
                        if(typeof targetValue!="object"){
                            targetValue=""
                            break;
                        }
                        targetValue = targetValue[key]
                    }
                    if (el?.required && !targetValue) {
                        return { success: false, params: {} }
                    }
                    appendData(targetValue, el.label)
                }
                else{
                    if(el?.required && !el.value) {
                        return {success:false,params:{}}
                    }
                    if (el.value && typeof el.value!="number" && (el.value+"").includes("$self")) {
                        let value = $self
                        let keyArr = el.value.split(".")
                        keyArr = keyArr.slice(1)
                        for (let key of keyArr) {
                            if(typeof value!="object"){
                                value=""
                                break;
                            }
                            value = value[key]
                        }
                        appendData(value, el.label)
                    }
                    else {
                        appendData(el.value == 'self'  ? value : el.value, el.label)
                    }
                }
                // if (el.value) {
                // }
            }
            // item.targetParameters.forEach(el => {
            // });
        }
    
        function appendData(value, label = '') {
            let temp_method="apiMethod"
            if(type=="targetParameters"){
                temp_method="targetAPIMethod"
            }
            if (item[temp_method] == 'get') {
                if (!obj) obj = []
                obj.push(encodeURIComponent(label) + '=' + encodeURIComponent(value))
            }
            else if (item[temp_method] == 'get_URI') {
                if (!obj) obj = ''
                obj += encodeURIComponent(value)
            }
            else {
                if (!obj) obj = {}
                obj[label] = value
            }
        }
    
        return {success:true,params:obj}
    }
    catch(e){
        return {success:false,params:{}}
    }
}

export const handleDynamicChange = async(rowElement={},item={},option={},storeDetailIn="",extraReadFormResponse=[],isShowMessage=false) => {//itemDetail
    if(item.setTargetValue && item.targetAPI){
        await customAPI_For_TargetAPIPara(item,option,extraReadFormResponse,rowElement,isShowMessage,(response)=>{
            try {
              
                if (item.onChangeSet) {
                    calculateTarget(rowElement,item, response || null)
                }
                else if(item.targetElement){
                    let keyArr=item.targetElement.split(".")
                    let value=""
                    if(keyArr.length==1){
                        value=response[item.targetElement]
                    }
                    else{
                        for (let key of keyArr) {
                            if(value){
                                value = value[key]
                            }
                            else{
                                value=""
                                break;
                            }
                        }
                    }
                    
                    setTarget(rowElement,item.targetElement, value)
                }
                if(storeDetailIn){
                    rowElement[storeDetailIn]=response || null
                }
            }
            catch (e) {
                console.log(e.message);              
            }
        })  
    }
    else if (item.setTargetValue) {
        if (item.onChangeSet) {
            try {
                calculateTarget(rowElement,item)
            }
            catch (e) {
                console.log(e.message);         
            }
        }
    }
}

export const customAPI_For_APIPara = async(item={},value,detailObject={},cb) => {
    let {success,params={}}=calculateTargetAPIParams(deepCopy_Object(item),value,"apiParameters",detailObject)
    if(!success){
        cb([])
        return
    }
    const {passToken=null,apiEndPoint,apiDataReturnKey,apiBindingKey,apiBindingValue,suffix="",extraValue=[],baseURL="",renderOption=[]}=item
    // console.log("baseURL",baseURL)
    let connection=getConnection(baseURL,passToken)
    // console.log("connection",connection)
    await connection.post(`/${apiEndPoint}`, {...params}).then(({data}) => {
        if(!data.success && !data.error) data["success"]=true
        if(data.success){
            let allData=data[apiDataReturnKey || "data"] || []
            let values=allData.map((dl)=>{
                
                let tempBindingKey=apiBindingKey || item?.keyForLabel || ""
                let tempBindingValue=apiBindingValue || item?.keyForValue || ""
                let label="",value="",renderOptionLabel
                if(Array.isArray(tempBindingKey)){
                    for(let key of tempBindingKey){
                        let value = dataReadFunction({name:key},dl,"name",false,{},true)
                        if(value){
                            label=value
                            break;
                        }
                    }
                }
                else {
                    // console.log("tempBindingKey",{tempBindingKey,renderOption})
                    
                    label = dataReadFunction({name:tempBindingKey},dl,"name",false,{},true) || ""
                    if (Array.isArray(renderOption) && renderOption?.length > 0) {
                        renderOptionLabel = renderOptionHandler(dl, renderOption,true)
                    }

                }
                if(Array.isArray(tempBindingValue)){
                    for(let key of tempBindingValue){
                      let value = dataReadFunction({name:key},dl,"name",false,{},true)
                        if(value){
                            label=value
                            break;
                        }
                    }
                }
                else{
                    value= dataReadFunction({name:tempBindingValue},dl,"name",false,{},true)|| ""
                }
                
                if(suffix && dl[suffix]){
                    label=label +"("+ dl[suffix] +")"
                }
                let obj={label,value}
                if(renderOptionLabel){
                    obj["renderOptionLabel"]=renderOptionLabel
                }

                if (extraValue?.length) {
                    for (let option of extraValue) {
                        if (typeof option == "object" && !Array.isArray(option)) {
                            if (option.label) {
                                if (option?.label == "all") {
                                    let { id, _id, ...rest } = dl
                                    Object.assign(obj, rest);
                                    break;
                                }
                                obj[option.label] = option?.isStaticValue == true ? option?.value : dl[option?.value] || ""
                            }
                        }
                        else if (typeof option == "string") {
                            if (option == "all") {
                                let { id, _id, ...rest } = dl
                                Object.assign(obj, rest);
                                break;
                            }
                            obj[option] = dl[option] || ""
                        }
                    }
                }
                return obj
            })
            cb(values)
        }
        else{
            cb([])
        }
    }).catch((error) => {
        console.log("ERROR", error);
        cb([])
    })
}


export const customAPI_For_TargetAPIPara = async(item={},option,extraReadFormResponse=null,rowElement={},isShowMessage=false, cb) => {
    let {success,params={}}=calculateTargetAPIParams(deepCopy_Object(item),option,"targetParameters")
    if(!success){
        cb(null)
        return;
    }
    const {passToken=null,targetAPI,targetAPIMethod,targetApiDataReturnKey,baseURL}=item
    let connection=getConnection(baseURL,passToken)
    await connection.post(`/${targetAPI}`, {...params}).then(({data}) => {
        if(!data.success && !data.error) data["success"]=true
        if(isShowMessage){
            showToast(data.message,!data["success"])
        }
        if(data.success){
            let dataObj=data[targetApiDataReturnKey || "data"] || {}
            if(extraReadFormResponse?.length>0 && Array.isArray(extraReadFormResponse)){

                for(let ele of extraReadFormResponse){
                    if(data[ele]){
                        rowElement[ele]=data[ele]
                    }
                }
                cb(dataObj)
            }
            else{
                cb(dataObj)
            }
        }
        else{
            cb(null)
        }
    }).catch((error) => {
        cb(null)
    })
}


export const getOptionValueLabel = (head = {}, value = "", formDataDynamicLabel = {}) => {
    // Handle dynamic case
    if (!value) return "-";
    if (head?.dynamic) {
        return formDataDynamicLabel[value] ? formDataDynamicLabel[value] : value;
    }
    let tempValue = value && typeof value == "string" ? value.toLowerCase() : value
    const values = head?.values || []

    // Handle check case (when value is an array)
    if (head?.type === "checkbox" && Array.isArray(value)) {
        if (value.length == 0) return "-";
        return value
            .map(val => values?.find(option => (typeof option?.value == "string" ? option?.value?.toLowerCase() : option?.value) == (val && typeof val == "string" ? val.toLowerCase() : val))?.label || "-")
            .join(", ");
    }

    // Default case: find and return the label
    if (!value) return "-";
    return values?.find(option => (typeof option?.value == "string" ? option?.value?.toLowerCase() : option?.value) == tempValue)?.label || "-";
};


export const getFormLabelValueDetails = (detailArr = [], templateHeader, source, excludeKeys = [], excludeTypes = ["heading", "file", "paragraph"]) => {
    if (!templateHeader) return;
    templateHeader.filter(head => !excludeTypes.includes(head.type) && !excludeKeys.includes(head.name))
        .forEach((head) => {
            let value = dataReadFunction(head, source, "name")
            value = ["select", "radio", "checkbox"].includes(head.type)
                ? getOptionValueLabel(head, value)
                : Array.isArray(value)
                    ? value.join(", ")
                    : ["date", "datetime"].includes(head.type)
                        ? value && dateTimeFormater(value, head?.format) || '-'
                        : value || '-'

            detailArr.push({ label: head.label, value });
        });
};
